import PageRendererHelperBase from './PageRendererHelperBase';
import { GraphicItemUtils } from '../../../../utils/GraphicItemUtils';
import { fabric } from 'fabric';
import PicabooConstants from '../../../../common/PicabooConstants';

export default class PageRendererShapeHelper extends PageRendererHelperBase {
  drawShape(pi, itemWidth, itemHeight, x, y) {
    return new Promise((resolve) => {
      let shape = this.getExistingCanvasObject(pi);

      let options = {
        ...this.getDefaultItemOptions(),
        left: x,
        top: y,
        angle: this.fixRotation(pi.get('rotation')),
        pageItemVO: pi,
      };

      options.fill = pi.get('fillEnabled')
        ? GraphicItemUtils.toColor(pi.get('fillColor'), pi.get('alpha') || 1)
        : 'transparent';

      if (
        !global.isDesigner &&
        (pi.get('type') === PicabooConstants.WELL_TYPES.ALWAYS_ON_TOP ||
          pi.get('type') === PicabooConstants.WELL_TYPES.FIXED_ELEMENT)
      ) {
        options.selectable = false;
        options.hoverCursor = 'default';
      }

      if (pi.get('borderEnabled')) {
        options.stroke = GraphicItemUtils.toColor(pi.get('borderColor'));
        options.strokeWidth = this.calcActualBorderThickness(
          pi.get('borderSize'),
          this.ratioWidth,
        );
      } else {
        options.strokeWidth = 0;
      }

      let shapeType = pi.get('shapeType') || 'line';

      switch (shapeType) {
        case 'line':
          options.stroke = GraphicItemUtils.toColor(pi.get('color'));
          options.strokeWidth =
            (pi.get('thickness') * this._dim.scale) / this._dim.ratioBase;
          options.strokeLineCap = pi.get('caps') || 'square';
          options.centeredRotation = true;
          if (pi.get('pattern') === 'dotted') {
            options.strokeLineCap = 'round';
            options.strokeDashArray = [1, options.strokeWidth + 2];
          } else if (pi.get('pattern') === 'dashed') {
            options.strokeDashArray = [
              options.strokeWidth * 2,
              options.strokeWidth * 2,
            ];
          } else if (pi.get('pattern') === 'solid') {
            options.strokeDashArray = null;
          }
          options.lockScalingY = true;
          options.height = 0;
          options.lockSkewingY = true;
          options.lockSkewingX = true;
          options.scaleX = 1;
          options.scaleY = 1;

          itemWidth = Math.max(itemWidth - options.strokeWidth, 1);

          if (!shape) {
            let points = [x, y, x + itemWidth, y];
            shape = new fabric.Line(points, options);
            shape.set('left', x);
            shape.set('top', y);
            shape.set('width', itemWidth);
            shape.set('originX', 'left');
            shape.set('originY', 'top');
            shape.setCoords(false);
          } else {
            shape.set(options);
            shape.set('left', x);
            shape.set('top', y);
            shape.set('width', itemWidth);
            shape.set('originX', 'left');
            shape.set('originY', 'top');
            shape.setCoords(false);
          }
          break;
        case 'square':
          options.lockSkewingY = true;
          options.lockSkewingX = true;
          if (shapeType == 'square') {
            options.lockUniScaling = true;
          }
        //fall through
        case 'rect':
          options.width = itemWidth;
          options.height = itemHeight;

          if (!shape) {
            shape = new fabric.Rect(options);
          } else {
            shape.set(options);
          }
          break;
        case 'circle':
          options.radius = itemWidth / 2;
          if (!shape) {
            shape = new fabric.Circle(options);
          } else {
            shape.set(options);
          }
          break;
        case 'oval':
          options.rx = itemWidth / 2;
          options.ry = itemHeight / 2;
          if (!shape) {
            shape = new fabric.Ellipse(options);
          } else {
            shape.set(options);
          }
          break;
      }

      if (shape) {
        this.mobileControls(shape);

        if (
          (pi.get('dropShadow') && pi.get('dropShadow').get('enabled')) ||
          pi.get('shadowEnabled')
        ) {
          let shadow = pi.get('shadowEnabled')
            ? {
                color: 'rgba(0,0,0,0.6)',
                blur:
                  0.009 * this.ratioWidth +
                  (pi.get('borderEnabled') ? options.strokeWidth : 0.0),
                offsetX:
                  0.008 * this.ratioWidth +
                  (pi.get('borderEnabled') ? options.strokeWidth : 0.0),
                offsetY:
                  0.008 * this.ratioWidth +
                  (pi.get('borderEnabled') ? options.strokeWidth : 0.0),
                opacity: 1,
                affectStroke: false,
              }
            : this.getDropShadow(
                pi,
                pi.get('borderEnabled'),
                options.strokeWidth,
              );
          shape.setShadow(shadow);
        } else {
          shape.setShadow({});
        }

        if (shapeType == 'line') {
          // Locking the scaling on Y axis is not enough - we also have to hide the control boxes
          shape.setControlsVisibility({
            mt: false, // middle top disable
            mb: false, // middle bottom
            bl: false, // bottom left
            br: false, // bottom right
            tl: false, // top left
            tr: false, // top right
            ml: true, // middle left
            mr: true, // middle right
          });
        }

        if (shapeType == 'circle') {
          shape.setControlsVisibility({
            mt: false, // middle top disable
            mb: false, // middle bottom
            bl: true, // bottom left
            br: true, // bottom right
            tl: true, // top left
            tr: true, // top right
            ml: false, // middle left
            mr: false, // middle right
          });
        }
      }
      resolve(shape);
    });
  }
}
